export const getLocalPrinterStorageKey = (id: number | string) =>
    "local_printer_" + id
